import { g } from '~/globals';

export default function logoutAction() {
  // We can not just clear everything as we don't want to loose the kiosk mode
  g.reg.auth.signOut().finally(() => {
    // Remove all data that is present cached
    g.reg.queryClient.clear();

    // Clear localstorage: We can't just do this, as the kiosks demand an item to be set
    // TODO: Figure out if it is reasonable not to do anything else
    // localStorage.clear();

    // Reset session storage
    sessionStorage.clear();
    window.location.href = '/';
  });
}
